import LABEL from '../../../business-const/Label/Label'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    TextValidatorText,
    TextValidatorNumber,
    TextValidatorNumberRequired,
    TextValidatorValor,
} from '../../../business-components/TextValidator/TextValidator'



export const IdadeInicial = ({ values, item, ind, handleChange }) => {

    const TextValidatorIdadeInicial = item.aporteAnual || item.retiradaAnual ? TextValidatorNumberRequired : TextValidatorNumber

    return (
        <TextValidatorIdadeInicial
            name={`aporteRetiradaAnual[${ind}].idade`}
            label={LABEL.idade}
            value={item.idade === 0 ? 0 : item.idade || ''}
            onChange={handleChange}
            numMin={values.idadeDataSimulacaoCliente}
            numMax={values.idadeFinalVitalicioClienteConjuge}
        />
    )
}

export const IdadeFinal = ({ values, item, ind, handleChange }) => {

    return (
        <TextValidatorNumber
            name={`aporteRetiradaAnual[${ind}].idadeFinal`}
            label={LABEL.idadeFinalOpcional}
            value={item.idadeFinal === 0 ? 0 : item.idadeFinal || ''}
            onChange={handleChange}
            numMin={values.idadeDataSimulacaoCliente}
            numMax={values.idadeFinalVitalicioClienteConjuge}
        />
    )
}

export const Mes = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorNumber
            name={`aporteRetiradaAnual[${ind}].mes`}
            label={LABEL.mesOpcional}
            value={item.mes === 0 ? 0 : item.mes || ''}
            onChange={handleChange}
            numMin={NUMMIN.mes}
            numMax={NUMMAX.mes}
        />
    )
}

export const AporteAnual = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorValor
            name={`aporteRetiradaAnual[${ind}].aporteAnual`}
            label={LABEL.aporteAnual}
            value={item.aporteAnual || ''}
            onChange={handleChange}
        />
    )
}

export const RetiradaAnual = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorValor
            name={`aporteRetiradaAnual[${ind}].retiradaAnual`}
            label={LABEL.retiradaAnual}
            value={item.retiradaAnual || ''}
            onChange={handleChange}
        />
    )
}

export const Observacao = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorText
            name={`aporteRetiradaAnual[${ind}].observacao`}
            label={LABEL.observacao}
            value={item.observacao || ''}
            onChange={handleChange}
            tamMax={TAMMAX.observacao}
        />
    )
}